import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { PartnerApi } from 'api';

function useGetAll() {
  return useAuthQuery(getQueryKeys([KEY]).lists(), () => PartnerApi.getAll(), {
    select: (data) => data.data,
  });
}

export default useGetAll;
